import { useEffect } from "react";

// import { Link } from 'react-router-dom';

const RegionalTrades = () => {
  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList.remove("fixed-header-desktop");
    },
    false
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList.remove("fixed-header-desktop");
      // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    },
    false
  );

  return (
    <div>
      <div id="international" className="regional-trade-image">
        <img
          src="/regional-trade/Product-Banner-Regional-Trade-TIR.jpg"
          alt=""
          className="w-[100%]"
        />
      </div>
      <div className="flex flex-col justify-center  gap-4 max-w-[50rem] mx-auto  pr-[3rem] pl-[3rem] pt-[2rem] mb-[100px]">
        <p>
          Pakistan’s geographic location makes it an ideal gateway for Central
          Asian trade and combined with Afghanistan, offers a cost effective and
          time efficient transit corridor, linking Central Asian Republics with
          global markets. Sensing the opportunity, TCS, carrying a commercial
          load of medicines, opened the Pak Afghan corridor in 2021 as a transit
          route for Uzbekistan, Kazakhstan, Tajikistan, Kyrgyzstan, and beyond.
        </p>
        <p>
          We move cargo from ports of origin to Karachi by sea, and truck
          onwards to destinations in the Central Asian cluster and beyond. Our
          services include cargo pickup at origin, shipping, port and custom
          clearance, cross stuffing and border crossing solutions. We partner
          with marine freight forwarders for sea logistics and 3rd party vendors
          for trucking requirements, including ambient and
          temperature-controlled containers.
        </p>
        <p>
          In 2018 TCS became the 1st recipient of the TIR license awarded by the
          Pakistan National Council of the International Chamber of Commerce and
          offers customers a choice between regular trucking and TIR - allows
          containers to pass without being checked by customs at border crossing
          points, as per the 1975 TIR UN convention.
        </p>
        <p>
          The Pakistan Afghanistan corridor offers significant savings on cost
          and, more importantly, journey time as compared to bilateral and
          transit cargo movements through the traditional supply chain.
        </p>
      </div>
    </div>
  );
};
export default RegionalTrades;
